let lastKnownEmail: string | null = null;

export const setLastKnownEmail = (value: string) => {
  lastKnownEmail = value;
};

export const getLastKnownEmail = () => lastKnownEmail;

export const clearLastKnownEmail = () => {
  lastKnownEmail = null;
};
